export const batchData = [
  {
    id: "b1",
    label: "AI/ML 1 year",
    color: { bg: "#CECBF6", text: "#3C3489" },
    startTime: "10:00",
    endTime: "11:00",
    students: 24,
    days: [1, 2, 3, 4, 5],
    progress: 65,
    instructor: "Gurnoor",
  },
  {
    id: "b2",
    label: "Digital Marketing",
    color: { bg: "#9FE1CB", text: "#085041" },
    startTime: "10:00",
    endTime: "11:00",
    students: 18,
    days: [1, 2, 3, 4, 5],
    progress: 40,
    instructor: "Nov",
  },
  {
    id: "b3",
    label: "Web Design",
    color: { bg: "#F5C4B3", text: "#712B13" },
    startTime: "10:00",
    endTime: "11:00",
    students: 15,
    days: [1, 2, 3, 4, 5],
    progress: 55,
    instructor: "Sukhp",
  },
  {
    id: "b4",
    label: "Python Apr 2026",
    color: { bg: "#FAC775", text: "#633806" },
    startTime: "13:00",
    endTime: "14:00",
    students: 20,
    days: [1, 2, 3, 4, 5],
    progress: 20,
    instructor: "Simran",
  },
  {
    id: "b5",
    label: "Overseas Training",
    color: { bg: "#C0DD97", text: "#27500A" },
    startTime: "13:00",
    endTime: "14:00",
    students: 12,
    days: [1, 2, 3, 4, 5],
    progress: 70,
    instructor: "Microso",
  },
  {
    id: "b6",
    label: "ML-Rishav",
    color: { bg: "#B5D4F4", text: "#0C447C" },
    startTime: "14:00",
    endTime: "15:00",
    students: 10,
    days: [1, 2, 3, 4, 5],
    progress: 80,
    instructor: "Rishav",
  },
];

